// Extracted verbatim from views/CaseDetail.js (PART C). Imports are the union
// used across the case-detail tabs; unused ones in a given tab are harmless.
import React, { useEffect, useRef, useState } from "react";
import CenteredModal from "../../components/CenteredModal";
import Spinner from "../../components/Spinner";
import Confirm from "../../components/Confirm";
import Modal from "../../components/Modal";
import { TipoPill, EstadoPill, SlaPill, TipoFalloPill, ESTADO_LABEL, PREFER_SUB_TIPO_STATES } from "../../components/Pills";
import { formatTipo } from "../../utils/case_taxonomy";
import { cases, insumos as insumosApi, users as usersApi, moderation as moderationApi } from "../../api/endpoints";
import { useAuth } from "../../auth/AuthContext";
import { useToast } from "../../components/Toast";
import InsumosTab from "../insumos/InsumosTab";
import LitisoftFields from "../../components/LitisoftFields";
import LitisoftIncompleteModal from "../../components/LitisoftIncompleteModal";
import LitisoftMandatoryInline from "../../components/LitisoftMandatoryInline";
import { TERMINO_OPTIONS, formatTermino } from "../../utils/termino";
import { canMarkContestadaDirectly, canRequestModeration, availableContestadaCategorias, CONTESTADA_LABELS as CONTESTADA_LABELS_FULL, rolesOf } from "../../utils/permissions";
import LawyerActionPanel from "../../components/lawyer/LawyerActionPanel";
import ProcesoCarpetasBanner from "../../components/ProcesoCarpetasBanner";
import CarpetaDocumentsPanel from "../../components/CarpetaDocumentsPanel";
import CarpetaStatusBadge from "../../components/CarpetaStatusBadge";
import InlineEditAccionante from "../../components/InlineEditAccionante";
import TipoFalloEditModal from "../../components/TipoFalloEditModal";
import { PERSONA_EDIT_ROLES } from "../Personas";
import { fmt, InlineEdit, hasLawyerRole, MarcarContestada, CaseFlagsToggles, hasSancionesSpecialization, SancionLifecycle, MarcarInsumoDeficiente, SolicitarModeracion, LawyerAgencyButtons, TABS, CONTESTADA_LABELS } from "./shared";

export default function HistorialTab({ c }) {
  const log = c.audit_log || [];
  if (!log.length) return <p className="muted">Sin registros.</p>;
  return (
    <>
      <h3 style={{ marginTop: 0 }}>Historial</h3>
      <ol style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {log.map(e => (
          <li key={e.id} style={{ display: "flex", gap: 12, padding: "10px 0", borderBottom: "1px solid var(--border-hairline)" }}>
            <div style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--accent-mint)", marginTop: 6 }} />
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 500, color: "var(--text-primary)" }}>
                {e.actor_name || "Sistema"} · <span style={{ fontWeight: 400, color: "var(--text-muted)" }}>{e.action}</span>
              </div>
              <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
                {e.from_state && e.to_state && `${e.from_state} → ${e.to_state} · `} {fmt(e.created_at)}
              </div>
              {e.notes && <div style={{ fontSize: 12 }}>{e.notes}</div>}
            </div>
          </li>
        ))}
      </ol>
    </>
  );
}

// ===========================================================================
// Auditoría tab — approve/reject with same-auditor enforcement
// ===========================================================================
